import { MutationTree } from 'vuex';
import { ICreateDirectoryState } from '@/content-library/directories/create/store/create-directory.types';
import { ECreateDirectoryMutation } from '@/content-library/directories/create/store/create-directory.constants';
import { IDirectory } from '@/api/directories/types/directory';

export const mutations: MutationTree<ICreateDirectoryState> = {
  [ECreateDirectoryMutation.SetCreating](state: ICreateDirectoryState, creating: boolean) {
    state.creating = creating;
  },
  [ECreateDirectoryMutation.SetCreatedDirectory](
    state: ICreateDirectoryState,
    directory: IDirectory
  ) {
    state.createdDirectory = directory;
  },
  [ECreateDirectoryMutation.SetDirectoryPath](state: ICreateDirectoryState, path: string) {
    state.directoryPath = path;
  },
  [ECreateDirectoryMutation.SetDirectoryNames](
    state: ICreateDirectoryState,
    existingNames: string[]
  ) {
    state.existingDirectoryNames = existingNames;
  },
  [ECreateDirectoryMutation.SetState](
    state: ICreateDirectoryState,
    newState: ICreateDirectoryState
  ) {
    state.directoryPath = newState.directoryPath;
    state.existingDirectoryNames = newState.existingDirectoryNames;
    state.createdDirectory = newState.createdDirectory;
    state.creating = newState.creating;
  },
};
